var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMdCalendarDots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75 0C5.16421 0 5.5 0.335786 5.5 0.75V2H10.5V0.75C10.5 0.335786 10.8358 0 11.25 0C11.6642 0 12 0.335786 12 0.75V2H13.25C14.2165 2 15 2.7835 15 3.75V14.25C15 15.2165 14.2165 16 13.25 16H2.75C1.7835 16 1 15.2165 1 14.25V3.75C1 2.7835 1.7835 2 2.75 2H4V0.75C4 0.335786 4.33579 0 4.75 0ZM13.25 3.5C13.3881 3.5 13.5 3.61193 13.5 3.75V5H2.5V3.75C2.5 3.61193 2.61193 3.5 2.75 3.5H13.25ZM2.5 6.5V14.25C2.5 14.3881 2.61193 14.5 2.75 14.5H13.25C13.3881 14.5 13.5 14.3881 13.5 14.25V6.5H2.5Z",
    fill: "#0052CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.03125 11C5.6008 11 6.0625 10.5523 6.0625 10C6.0625 9.44771 5.6008 9 5.03125 9C4.46171 9 4 9.44771 4 10C4 10.5523 4.46171 11 5.03125 11Z",
    fill: "#0052CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11C8.56955 11 9.03125 10.5523 9.03125 10C9.03125 9.44771 8.56955 9 8 9C7.43045 9 6.96875 9.44771 6.96875 10C6.96875 10.5523 7.43045 11 8 11Z",
    fill: "#0052CC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0625 10C12.0625 10.5523 11.6008 11 11.0312 11C10.4617 11 10 10.5523 10 10C10 9.44771 10.4617 9 11.0312 9C11.6008 9 12.0625 9.44771 12.0625 10Z",
    fill: "#0052CC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdCalendarDots);
export default __webpack_public_path__ + "static/media/md-calendar-dots.ec50b295ed67dbde05f3bf292dbb363c.svg";
export { ForwardRef as ReactComponent };